/**
 * Aviso de PRIMEIRA adição à estante — a explicação de onde sai a previsão de
 * leitura (o ritmo medido nas sessões de Modo Foco).
 *
 * Por que localStorage e não um campo no perfil: a whitelist de
 * `userOwnSafeFields` no `firestore.rules` rejeita campo novo escrito pelo
 * client, então um flag no `users/*` exigiria mudar as rules E deployá-las —
 * e até o deploy sair o aviso reapareceria a cada adição. Aqui o flag é por
 * uid (não global do device, pra duas contas no mesmo aparelho não roubarem o
 * aviso uma da outra) e segue o idioma que o repo já usa em `trackOnce` e
 * `defaultOwnedTracking`. Custo assumido: trocar de aparelho reexibe uma vez.
 *
 * Toda a superfície de troca pra Firestore está contida neste módulo — quem
 * consome só chama `announceFirstShelfAdd` e escuta o evento.
 */

const KEY_PREFIX = "livra_first_shelf_notice_";

/** Evento no `window` — o aviso é montado uma vez no App, longe de quem adiciona. */
export const FIRST_SHELF_NOTICE_EVENT = "livra:first-shelf-add";

function storageKey(uid: string): string {
  return `${KEY_PREFIX}${uid}`;
}

/**
 * `true` também quando não há storage disponível (aba anônima, storage
 * bloqueado). É a falha segura: sem onde gravar "já viu", mostrar o aviso a
 * CADA adição seria pior do que nunca mostrar.
 */
export function hasSeenFirstShelfNotice(uid: string): boolean {
  if (!uid) return true;
  try {
    return window.localStorage.getItem(storageKey(uid)) === "1";
  } catch {
    return true;
  }
}

export function markFirstShelfNoticeSeen(uid: string): void {
  if (!uid) return;
  try {
    window.localStorage.setItem(storageKey(uid), "1");
  } catch {
    /* storage indisponível — o aviso nunca bloqueia o fluxo de adicionar */
  }
}

/**
 * Chamado por QUALQUER superfície que acabou de criar um `user_book`. Não faz
 * nada se o usuário já viu. Nunca lança: adicionar livro não pode falhar por
 * causa de um aviso.
 */
export function announceFirstShelfAdd(uid: string): void {
  if (!uid || hasSeenFirstShelfNotice(uid)) return;
  try {
    window.dispatchEvent(new CustomEvent(FIRST_SHELF_NOTICE_EVENT));
  } catch {
    /* CustomEvent indisponível (SSR / browser antigo) */
  }
}
